// extracted by mini-css-extract-plugin
module.exports = {"table":"_2TmRFRM_kSFcvjB6W9TsM2","field-label":"_2Rrq1S_B4RJTWdLwWCBP2g","field-value":"_1Dqa6cSXqjWAu6B8Wag8yJ","cell-overflow-wrapper":"_2a40r_bUfTGNrSh-sVXSsp"};